import React, { useContext, useState } from "react";
import styles from "./PosterResults.module.css";
import Context from "../context/Context";
import backIcon from "../assests/posterCreation/backIcon.svg";
import user from "../assests/user.svg";
import { useUserAuth } from "../context/UserAuthContext";
import { useLocation, useNavigate, useParams } from "react-router";
import PosterResultsPopup from "../Components/PosterResultsPopup/PosterResultsPopup";
import { createSearchParams } from "react-router-dom";
import FloatingWidgets from "../Components/FloatingWidgets/FloatingWidgets";
import { useEffect } from "react";

function PosterResults() {
  const { occasion } = useParams();
  const { resultUrls, setResultUrls, preview, details } = useContext(Context);
  const { currentUser, setPreviousLocation, searchParams } = useUserAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [popup, setPopup] = useState(false);
  const [popupImageIndex, setPopupImageIndex] = useState("");
  const mode = window.location.pathname.split("/")[1]?.replace(/\.html$/, "");
  useEffect(() => {
    if (mode == "faceswap") {
      setPopup(true);
      setPopupImageIndex(0);
    }
  }, []);
  const handleLogin = () => {
    setPreviousLocation(window.location.pathname);
    if (preview) {
      navigate(
        {
          pathname: `/signup`,
          search: "?preview=true",
        },
        {
          state: {
            previousLocation: `/profile`,
          },
        }
      );
    } else {
      navigate(
        {
          pathname: `/signup`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        },
        {
          state: {
            previousLocation: `/profile`,
          },
        }
      );
    }
  };

  const handleProfileNavigate = () => {
    setPreviousLocation(window.location.pathname);
    if (preview) {
      navigate(
        {
          pathname: `/profile`,
          search: "?preview=true",
        },
        { state: { previousLocation: location?.pathname } }
      );
    } else {
      navigate(
        {
          pathname: `/profile`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        },
        { state: { previousLocation: location?.pathname } }
      );
    }
  };

  return (
    <>
      <FloatingWidgets
        page="campaign"
        prize={details?.priceDescription}
        endTime={details?.endDate}
        color={details?.btnColor}
        bgColor={details?.bgColor}
      />
      <div className={styles.posterResultsContainer}>
        {popup && (
          <PosterResultsPopup
            visible={popup}
            close={setPopup}
            popupImageIndex={popupImageIndex}
            resultData={resultUrls}
            occasion={occasion}
          />
        )}
        <div className="flex px-[20px] mt-[20px] mb-[24px] items-center justify-between w-full">
          <a href={`/poster/${occasion}`}>
            <img
              className="cursor-pointer"
              src={backIcon}
              alt=""
              onClick={() => {
                setResultUrls([]);
              }}
            />
          </a>
          <p className="text-black text-[15px] leading-[21px] font-semibold ">
            {mode == "faceswap" ? "Choose an photo" : "Generated Posters"}
          </p>
          <div>
            {currentUser ? (
              <>
                <img
                  src={currentUser?.photoURL ? currentUser?.photoURL : user}
                  alt=""
                  className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                  onClick={handleProfileNavigate}
                />
              </>
            ) : (
              <img
                src={user}
                alt=""
                className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                onClick={handleLogin}
              />
            )}
          </div>
        </div>
        <div className="w-full h-full">
          <div className={styles.posterResultbgContainer}>
            <div className="pt-[24px] pb-[20px]">
              <p className="text-black text-center  text-[16px] font-semibold leading-[22px] ">
                {mode == "faceswap"
                  ? "Share your best photo"
                  : "Share your best poster"}
              </p>
            </div>
            {resultUrls?.map((obj, i) => {
              // let value = obj?.result
              // let resultValue = value.split("/")
              return (
                // <a href={`/poster/${occasion}/${resultValue[5]}`} target='_blank'>
                <div
                  key={i}
                  className="px-[16px] pb-[16px]"
                  onClick={() => {
                    setPopup(true);
                    setPopupImageIndex(i);
                  }}
                  // onClick={() => {
                  //     navigate(`/poster/${occasion}/${resultValue[5]}`)
                  // }}
                >
                  <img
                    src={obj?.result}
                    alt=""
                    className="  rounded-[16px] w-full h-full"
                  />
                </div>
                // </a>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default PosterResults;
